'use strict';
require('./static');
require('es6-promise').polyfill();
require('string.prototype.startswith');
require('url-search-params-polyfill');

const I18next = require('i18next');
const ressBundle = require(
    "i18next-resource-store-loader!balus/locale/index.js"
);

const Key = require('common/domain/value/key');
const Backbone = require('backbone');
Object.defineProperty(Backbone.Model.prototype, 'key', {
    get() {
        return new Key(this.get('key'));
    }
});

const Mn = require('backbone.marionette');
const orgShowChildView = Mn.View.prototype.showChildView;
// Promise 内で showChildView をキックしているケースで、
// Promise が完了する前にに画面遷移すると親の View は先に destroy される。
// すでに View が destroy されている場合 showChildView を実行すると
// getRegion が null になってエラーが発生するため、
// isDestroyed の判定処理を入れておく。
Mn.View.prototype.showChildView = function(name, view) {
    if (this._isDestroyed) {
        return;
    }

    return _.bind(orgShowChildView, this)(name, view);
}

require('common/infra/loader').initialize(PROGRESS_BAR);
window.jQuery = require('jquery');
require('bootstrap');
require('bootstrap-material-design');
require('readmore-js');
const _ = require('underscore');
const Logger = require('common/util/logger');
const Radio = require('backbone.radio');
const Rollbar = require('common/infra/rollbar');
const GA = require('common/infra/google-analytics');
const Trackjs = require('common/infra/trackjs');
const Router = require('balus/app/router/index');
const UserAPI = require('common/infra/api/user');
const Dialog = require('common/util/dialog');
const AppInfoRepository = require('common/domain/repository/app-info');
const UserRepository = require('common/domain/repository/user');
const GroupAction = require('common/domain/action/group');
const GroupRepository = require('common/domain/repository/group');
const GroupRoleRepository = require('common/domain/repository/group-role');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const ProjectRepository = require('common/domain/repository/project');
const Context = require('common/domain/value/context');
const ActionContext = require('process/domain/value/context');
const DiagramContext = require('system/domain/value/context');
const DataContentContext = require('data/domain/value/context');
const UserSignupModal = require('common/ui/view/modal/user-signup');
const ActionRepository = require('process/domain/repository/action/index');
const ActionImportRepository = require('process/domain/repository/action/import');
const ReviewAction = require('notify/domain/action/review');
const GlobalMenuView = require('balus/ui/view/global-menu/index');
const HeaderView = require('balus/ui/view/header/index');
const SidepanelView = require('balus/ui/view/sidepanel/index');
const UserView = require('balus/ui/view/body/user/index');
const MyActionsView = require('balus/ui/view/body/my-actions/index');
const UserEmailActivationView = require('balus/ui/view/body/user-email-activation/index');
const InvitationView = require('balus/ui/view/body/invitation/index');
const AccountView = require('balus/ui/view/body/account/index');
let ActionView = require('balus/ui/view/body/process/index');
const ActionImportView = require('balus/ui/view/body/process-import/index');
const GroupView = require('balus/ui/view/body/group/index');
const RoleDashboardView = require('balus/ui/view/body/role-dashboard/index');
const GroupRoleView = require('balus/ui/view/body/group-role/index');
const ProjectRoleView = require('balus/ui/view/body/project-role/index');
const ProjectView = require('balus/ui/view/body/project/index');
const DiagramAction = require('system/domain/action/diagram');
const DiagramRepository = require('system/domain/repository/diagram');
const IdeaListView = require('feedback/ui/view/idea/list');
const IdeaDetailView = require('feedback/ui/view/idea/detail');
const IdeaRepository = require('feedback/domain/repository/idea');
const IdeaCollectionRepository = require('feedback/domain/repository/idea-collection');
const IdeaAdminView = require('feedback/ui/view/admin/idea/index');
const IdeaAdminDetailView = require('feedback/ui/view/admin/idea/detail');
const IdeaAdminEditView = require('feedback/ui/view/admin/idea/edit');
const AnnouncementRepository = require('feedback/domain/repository/announcement');
const AnnouncementManageRepository = require('feedback/domain/repository/announcement-admin');
const AnnouncementView = require('feedback/ui/view/announcement/index');
const AnnouncementManageView = require('feedback/ui/view/admin/announcement/index');
const AnnouncementDetailView = require('feedback/ui/view/announcement/detail');
const AnnouncementManageDetailView = require('feedback/ui/view/admin/announcement/detail');
const ModalView = require('common/ui/view/modal/index');
const UserSettingModal = require('common/ui/view/modal/user-setting');
const DiagramDashboardView = require('balus/ui/view/body/diagram-dashboard/index');
const DiagramView = require('balus/ui/view/body/diagram/index');
const DiagramImportView = require('balus/ui/view/body/diagram-import/index');
const DiffView = require('balus/ui/view/body/diagram-diff/index');
const DataContentDashboardView = require('balus/ui/view/body/data-content-dashboard/index');
const DataContentView = require('balus/ui/view/body/data-content/index');
const ContentRepository = require('data/domain/repository/content/index');
const ErrorView = require('common/ui/view/error');
const NotLoginErrorView = require('common/ui/view/not_login_error');
const ProjectErrorView = require('common/ui/view/project_error');
const SignInView = require('common/ui/view/signin');
const Util = require('common/util');
const BackboneValidationOverride = require('balus/util/backbone-validation-override');
const MomentConfig = require('balus/infra/moment/config');
const FirebaseMessenger = require('balus/domain/service/firebase-messenger');
const ViewerRepository = require('balus/domain/repository/viewer');
const ConcurrentEdit = require('balus/domain/service/concurrent-edit');
const MessageNotify = require('balus/domain/service/message-notify');
const DebugContext = require('common/util/debug-context/debug-context');
const DebugContextRepository = require('common/util/debug-context/debug-context-repository');

/**
 * App Engine のデフォルトドメインにアクセスされた際に、独自ドメインに fallback させる
 */
if (window && window.location) {
    const hostname = window.location.hostname;
    const href= window.location.href;

    if (hostname === 'balus-dev.appspot.com') {
        window.location.href = href.replace('balus-dev.appspot.com', 'dev.balus.me');
    }

    if (hostname === 'balus-stage.appspot.com') {
        window.location.href = href.replace('balus-stage.appspot.com', 'stage.balus.me');
    }

    if (hostname === 'balus-app.appspot.com') {
        window.location.href = href.replace('balus-app.appspot.com', 'app.balus.me');
    }
}

/**
 * externalLinkTargetBlank を登録
 */
if (window && window.location && jQuery) {
    (function ($) {
        $.fn.externalLinkTargetBlank = function () {
            const href1 = '//' + window.location.hostname + window.location.pathname;
            const href2 = '//' + window.location.hostname + ':' + window.location.port + window.location.pathname;

            return this.find('a').each(function (idx, item) {
                if (item.href.indexOf(href1) >= 0 || item.href.indexOf(href2) >= 0) {
                    // 現在表示中のページに対するリンクなので、 target 指定を変更しない
                } else if (item.href.indexOf('#') == 0 || item.href.indexOf('javascript') == 0) {
                    // '#' で始まるリンクなので、 target 指定を変更ない
                } else {
                    $(item).attr('target', '_blank');
                }
            });
        };
    })(jQuery);
}

const clientID = Util.generateId();
const isSignout = function(user, onSingoutCallback) {
    UserAPI.getLoginUser()
        .catch(obj => {
            if(obj.type == 'NotLoginError') {
                onSingoutCallback();
            }
        })
};


// クエリパラメータで debug が指定されていれば、設定値をシリアライズして Cookie に保存する
const updateDebugContext = () => {
    const urlParams = new URLSearchParams(location.search);
    const debugFlagStr = urlParams.get('debug');
    const repo = new DebugContextRepository();

    // debug クエリパラメータが未指定の時は DebugContext を変更しない
    if (debugFlagStr == null) {
        return;
    }

    // debug クエリパラメータで disabled が指定された時は、記録されている DebugContext を削除する
    if (debugFlagStr == 'disabled') {
        repo.delete();
        return;
    }

    const debugContext = repo.fetch();

    debugContext.setMode(debugFlagStr);

    _.each(DebugContext.OPTIONS, (key, urlKey) => {
        debugContext.setOptionMode(key, urlParams.get(urlKey));
    });

    if (location.search.indexOf("tngVersion") >= 0) {
        debugContext.setTNGVersion(urlParams.get("tngVersion"));
    }

    repo.put(debugContext);
};
const startOnDebug = () => {
    // クエリパラメータの指定があれば、Debug情報を更新してCookieに保存する
    updateDebugContext();

    // CookieからDebug情報を取得して、その情報に応じて各種セットアップを実行する
    const debugContext = (new DebugContextRepository()).fetch();
    if (debugContext.isDisabled()) {
        Logger.setLevel('info');
        return;
    }

    Logger.setLevel('debug');

    Logger.info(`clientID=${clientID}`);
    Logger.info(`debugContext=${JSON.stringify(debugContext.toJSON())}`);

    if (debugContext.getTNGVersion()) {
        // 接続先のTNGバージョンが標準と異なる場合、対象のインスタンスが停止している可能性があるので、
        // ヘルスチェック用エンドポイントを呼び出しておく
        const Ajax = require('common/infra/ajax');
        Ajax.GET('/api/hello-tng');
    }
};
startOnDebug();


const App = Mn.Application.extend({
    region: 'body',
    onStart: function() {
        const self = this;

        Promise.all([
            AppInfoRepository.get(),
            UserRepository.getLoginUser()
        ]).then(values => {
            const appInfo = values[0];
            const user = values[1];
            const applicationContext = Context.ApplicationContext.build(appInfo, user);

            self._onStart(applicationContext);
        });
    },
    _onStart: function(applicationContext) {
        const debugContext = (new DebugContextRepository()).fetch();

        const appInfo = applicationContext.getAppInfo();
        const user = applicationContext.getUser();

        const messengerChannel = Radio.channel(`messenger`);
        messengerChannel.on('all', () => {
        });

        $.ajaxSetup({
            headers: {'X-Channel-Client-Id': clientID}
        });
        const Messenger = new FirebaseMessenger();
        if (debugContext.getOptions().firebaseIsEnabled()) {
            Messenger.initialize(messengerChannel, user, clientID, appInfo);
        } else {
            Logger.info('Firebase is disabled, initialize skipped.');
        }

        new ConcurrentEdit(applicationContext, messengerChannel);
        const messageNotify = new MessageNotify(messengerChannel);
        messageNotify.setUser(user);
        this.listenTo(messengerChannel, 'msg:viewer:add', (viewerJSON, context) => {
            ViewerRepository.getViewer(context).add(viewerJSON);
        });
        this.listenTo(messengerChannel, 'msg:viewer:delete', (viewerJSON, context) => {
            ViewerRepository.getViewer(context).remove(viewerJSON);
        });
        this.listenTo(messengerChannel, 'msg:notify', notificationJSON => {
            ReviewAction.createReview(notificationJSON);
        });

        // サインアウトした場合に警告を出す
        if(user) {
            let signout = false;
            const checkSignout = () => {
                if(signout) {
                    return;
                }
                isSignout(user, () => {
                    signout = true;
                    Dialog.confirm({
                        okOnly: true,
                        text: I18next.t('balus:alert.signOut'),
                        okCallback: () => {
                            const loginURL = `/login?dst_url=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;
                            location.href = loginURL;
                        }
                    });
                });
            };
            setInterval(checkSignout, 60 * 60 * 1000);
        }

        const rootView = new (Mn.View.extend({
            el: '#root',
            regions: {
                globalMenu: '#global-menu-wrapper',
                header: '#header-wrapper',
                sidepanel: '#sidepanel-wrapper',
                body: '#body'
            }
        }))();
        this.showView(rootView);

        const globalMenuView = new GlobalMenuView({
            context: applicationContext
        });
        rootView.showChildView('globalMenu', globalMenuView);
        if(user && user.id) {
            $('#global-menu-wrapper').show();
        } else {
            $('#body').addClass('no-global-menu');
        }

        const headerView = new HeaderView({
            context: applicationContext
        });
        rootView.showChildView('header', headerView);
        if(user && user.id) {
            ReviewAction.fetchReviewsOnce({});
        }

        const sidepanelView = new SidepanelView({
            context: applicationContext
        });
        rootView.showChildView('sidepanel', sidepanelView);

        this.listenTo(headerView, 'toggle:review', () => {
            sidepanelView.toggleReview();
        });
        this.listenTo(headerView, 'toggle:task', () => {
            sidepanelView.toggleTask();
        });
        this.listenTo(sidepanelView, 'activate:review', () => {
            headerView.activateReview();
        });
        this.listenTo(sidepanelView, 'deactivate:review', () => {
            headerView.deactivateReview();
        });
        this.listenTo(sidepanelView, 'activate:task', () => {
            headerView.activateTask();
        });
        this.listenTo(sidepanelView, 'deactivate:task', () => {
            headerView.deactivateTask();
        });

        const setTitle = function(title) {
            document.title = title;
            $('title').text(title);
        };

        BackboneValidationOverride.overrideCallbacks();
        BackboneValidationOverride.overrideMessages();

        const groupReject = (groupId) => {
            return (reason) => {
                const statusCode = reason.status;
                if(statusCode == 403) {
                    if(user == null) {
                        rootView.showChildView('body', new NotLoginErrorView({
                            title: I18next.t('error:error_page.group_reject.403.title'),
                            info: I18next.t('error:error_page.group_reject.403.info'),
                        }));
                    }else{
                        rootView.showChildView('body', new ErrorView({
                            title: I18next.t('error:error_page.group_reject.403.title'),
                            info: I18next.t('error:error_page.group_reject.403.info'),
                            user: user,
                            statusCode: statusCode,
                        }));
                    }
                }
                if(statusCode == 404) {
                    rootView.showChildView('body', new ErrorView({
                        title: I18next.t('error:error_page.group_reject.404.title'),
                        info: '',
                        user: user,
                        statusCode: statusCode,
                    }));
                }
            };
        };

        const projectReject = (projectId) => {
            return (reason) => {
                const statusCode = reason.status;
                if(statusCode == 403) {
                    if(user == null) {
                        rootView.showChildView('body', new NotLoginErrorView({
                            title: I18next.t('error:error_page.group_reject.403.title'),
                            info: I18next.t('error:error_page.group_reject.403.info'),
                        }));
                    }else{
                        rootView.showChildView('body', new ErrorView({
                            title: I18next.t('error:error_page.project_reject.403.title'),
                            info: I18next.t('error:error_page.project_reject.403.info'),
                            user: user,
                            statusCode: statusCode,
                        }));
                    }
                }
                if(statusCode == 404) {
                    rootView.showChildView('body', new ErrorView({
                        title: I18next.t('error:error_page.project_reject.404.title'),
                        info: '',
                        user: user,
                        statusCode: statusCode,
                    }));
                }
            };
        };

        const processReject = (processId, context) => {
            return (reason) => {
                const statusCode = reason.status;
                const project = context.getProject();
                if(statusCode == 403) {
                    if(user == null) {
                        rootView.showChildView('body', new NotLoginErrorView({
                            title: I18next.t('error:error_page.group_reject.403.title'),
                            info: I18next.t('error:error_page.group_reject.403.info'),
                        }));
                    }else{
                        rootView.showChildView('body', new ProjectErrorView({
                            title: I18next.t('error:error_page.process_reject.403.title'),
                            info: I18next.t('error:error_page.process_reject.403.info'),
                            user: user,
                            statusCode: statusCode,
                            activeTab: 'process',
                            model: project,
                            context: context
                        }));
                    }
                }
                if(statusCode == 404) {
                    rootView.showChildView('body', new ProjectErrorView({
                        title: I18next.t('error:error_page.process_reject.404.title'),
                        info: I18next.t('error:error_page.process_reject.404.info'),
                        user: user,
                        statusCode: statusCode,
                        activeTab: 'process',
                        model: project,
                        context: context
                    }));
                }
            };
        };

        Router.on('all', () => {
            GA.viewPage();
        });

        Router.on('user', () => {
            setTitle('Home');
            Messenger.onElse();
            messageNotify.setContext({});
            headerView.hideGroupLicense();

            if(!user || !user.id) {
                rootView.showChildView('body', new SignInView());
                headerView.hideGroup();
            } else {
                rootView.showChildView('body', new UserView({
                    context: applicationContext,
                    model: user
                }));
                globalMenuView.showItemList(user, {isMyProjects: true});
                headerView.hideGroup();
                sidepanelView.showReview();
                headerView.activateReview();
            }
        });

        Router.on('myActions', () => {
            setTitle('My Actions');
            Messenger.onElse();
            messageNotify.setContext({});
            headerView.hideGroupLicense();

            if(!user || !user.id) {
                rootView.showChildView('body', new SignInView());
                headerView.hideGroup();
            } else {
                rootView.showChildView('body', new MyActionsView({
                    context: applicationContext,
                    model: user
                }));
                globalMenuView.showItemList(user, {isMyActions: true});
                headerView.hideGroup();
                sidepanelView.showReview();
                headerView.activateReview();
            }
        });

        Router.on('signup', () => {
            setTitle('Sign up');
            Messenger.onElse();
            messageNotify.setContext({});
            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();

            UserRepository.getJijiUser()
                .then(jijiUser => {
                    // プロダクション環境では 2 重のユーザー作成は不許可(Site Admin は除く)
                    if(appInfo.isProduction()) {
                        if(user && (user.id && !user.isSiteAdmin())) {
                            Router.navigate('/', {trigger: true});
                            return;
                        }
                    }

                    if(jijiUser) {
                        const modal = new ModalView({
                            title: I18next.t('title.user.signup'),
                            saveButtonEnable: false,
                            cancelButtonDisabled: true,
                            bodyView: new UserSignupModal({model: jijiUser}),
                            onChildviewSave: function() {
                                this.disableButtons();
                                this.getOption('bodyView').setting()
                                    .then(() => {
                                        this.hide();
                                    });
                            }
                        });
                        modal.show();
                    }
                })
                .catch(()=> {
                    const params = new URLSearchParams(window.location.search);
                    const dstURL = params.get('dst_url');
                    if (dstURL && dstURL.startsWith('/') && dstURL.indexOf('//:') < 0) {
                        Router.navigate(dstURL, {trigger: true});
                    } else {
                        Router.navigate('/', {trigger: true});
                    }
                });
        });

        Router.on('invitation', () => {
            setTitle('Invitation');
            messageNotify.setContext({});
            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();

            rootView.showChildView('body', new InvitationView({model: user}));
        });

        Router.on('userEmailActivate', token => {
            setTitle(I18next.t('balus_template_body_user_email_activation:title'));
            Messenger.onElse();
            messageNotify.setContext({});
            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();

            rootView.showChildView(
                'body',
                new UserEmailActivationView({
                    user: user,
                    token: token
                })
            );
        });

        Router.on('account', () => {
            setTitle('Account');
            messageNotify.setContext({});
            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();

            rootView.showChildView('body', new AccountView({model: user, appInfo: appInfo}));
        });

        Router.on('group', groupId => {
            GroupAction.fetchGroupOnce(groupId)
                .then(() => {
                    Messenger.onGroup(groupId);
                    messageNotify.setContext({groupId: groupId});
                    const group = GroupRepository.getGroups().get(groupId);
                    const groupMember = group.getMembers().getMemberByUser(user);
                    const roleID = groupMember ? groupMember.getRole() : 'anonymous';

                    setTitle(`Group - ${group.get('name')}`);
                    Messenger.onElse();
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();

                    GroupRoleRepository.find(group).getRole(roleID)
                        .then(groupRole => {
                            const context = new Context.GroupContext(appInfo, user, group, groupRole);

                            rootView.showChildView('body', new GroupView({
                                model: group,
                                context: context
                            }));
                        });
                }, groupReject(groupId));
        });

        Router.on('roleDashboard', groupId => {
            GroupAction.fetchGroupOnce(groupId)
                .then(() => {
                    messageNotify.setContext({groupId: groupId});
                    const group = GroupRepository.getGroups().get(groupId);
                    setTitle(`Roles - ${group.get('name')}`);
                    Messenger.onElse();
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();

                    rootView.showChildView('body', new RoleDashboardView({
                        model: group,
                        user: user
                    }));
                }, groupReject(groupId));
        });

        Router.on('groupRole', (groupID, roleID) => {
            GroupAction.fetchGroupOnce(groupID)
                .then(() => {
                    messageNotify.setContext({groupID: groupID});
                    const group = GroupRepository.getGroups().get(groupID);
                    setTitle(`Group Roles - ${group.get('name')}`);
                    Messenger.onElse();
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();

                    GroupRoleRepository.find(group).getRole(roleID)
                        .then(groupRole => {
                            rootView.showChildView('body', new GroupRoleView({
                                model: groupRole,
                                group: group,
                                user: user
                            }));
                        });
                }, groupReject(groupID));
        });

        Router.on('projectRole', (groupID, roleID) => {
            GroupAction.fetchGroupOnce(groupID)
                .then(() => {
                    messageNotify.setContext({groupID: groupID});
                    const group = GroupRepository.getGroups().get(groupID);
                    setTitle(`Project Roles - ${group.get('name')}`);
                    Messenger.onElse();
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();

                    ProjectRoleRepository.find(group).getRole(roleID)
                        .then(projectRole => {
                            rootView.showChildView('body', new ProjectRoleView({
                                model: projectRole,
                                group: group,
                                user: user
                            }));
                        });
                }, groupReject(groupID));
        });

        Router.on('project', projectId =>{
            ProjectRepository.getProject(projectId)
                .then(project => {
                    Messenger.onProject(projectId);
                    messageNotify.setContext({projectId: projectId});

                    GroupRepository.getGroup(project.getGroupId()
                    ).then(group => {
                        setTitle(`Project - ${project.get('name')}`);
                        globalMenuView.showItemList(group);
                        headerView.showGroup(group);
                        headerView.showGroupLicense(group);
                        sidepanelView.close();

                        const groupMember = group.getMembers().getMemberByUser(user);
                        const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                        const projectMember = project.getMembers().getMemberByUser(user);
                        const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                        Promise.all([
                            GroupRoleRepository.find(group).getRole(groupRoleID),
                            ProjectRoleRepository.find(group).getRole(projectRoleID),
                        ])
                            .then(values => {
                                const groupRole = values[0];
                                const projectRole = values[1];
                                const context = new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);

                                rootView.showChildView('body', new ProjectView({
                                    model: project,
                                    context: context
                                }));
                            });
                    });
                }, projectReject(projectId));
        });

        Router.on('diagramDashboard', projectId => {
            DiagramAction.fetchDiagramsOnce(projectId, null);
            ProjectRepository.getProject(projectId)
                .then(project => {
                    Messenger.onProject(projectId);
                    messageNotify.setContext({projectId: projectId});

                    GroupRepository.getGroup(project.getGroupId()
                    ).then(group => {
                        setTitle(`Project - ${project.get('name')}`);
                        globalMenuView.showItemList(group);
                        headerView.showGroup(group);
                        headerView.showGroupLicense(group);
                        sidepanelView.close();
                        const groupMember = group.getMembers().getMemberByUser(user);
                        const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                        const projectMember = project.getMembers().getMemberByUser(user);
                        const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                        Promise.all([
                            GroupRoleRepository.find(group).getRole(groupRoleID),
                            ProjectRoleRepository.find(group).getRole(projectRoleID),
                        ])
                            .then(values => {
                                const groupRole = values[0];
                                const projectRole = values[1];
                                const context = new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);

                                rootView.showChildView('body', new DiagramDashboardView({
                                    model: project,
                                    context: context
                                }));
                            });
                    });
                }, projectReject(projectId));
        });

        Router.on('diagram', (projectID, diagramID) =>{
            const urlParams = new URLSearchParams(location.search);
            const dt = urlParams.get('dt');
            DiagramAction.fetchDiagramsOnce(projectID, dt);
            Promise.all([
                ProjectRepository.getProject(projectID),
                DiagramAction.fetchDiagramOnce(projectID, diagramID, dt)
            ]).then(values => {
                const project = values[0];
                const diagram = DiagramRepository.getDiagrams({
                    context: {
                        projectId: projectID,
                        dt: dt
                    }
                }).get(diagramID);
                Messenger.onDiagram(projectID, diagramID);
                messageNotify.setContext({
                    projectId: projectID,
                    diagramId: diagramID
                });

                const channel = Radio.channel(`diagrams:${diagram.id}`);

                GroupRepository.getGroup(project.getGroupId()).then(group => {
                    setTitle(`Diagram - ${diagram.get('name')}`);
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();
                    const groupMember = group.getMembers().getMemberByUser(user);
                    const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                    const projectMember = project.getMembers().getMemberByUser(user);
                    const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                    Promise.all([
                        GroupRoleRepository.find(group).getRole(groupRoleID),
                        ProjectRoleRepository.find(group).getRole(projectRoleID),
                    ])
                        .then(values => {
                            const groupRole = values[0];
                            const projectRole = values[1];
                            const dt = DiagramContext.parseDtFromURLParams();
                            const context = new DiagramContext(appInfo, user, group, groupRole, project, projectRole, diagram, dt);

                            rootView.showChildView('body', new DiagramView({
                                model: diagram,
                                context: context,
                                channel: channel,
                                messengerChannel: messengerChannel
                            }));
                        });
                });
            }, projectReject(projectID));
        });

        Router.on('diagramImportRequest', (projectID, diagramID, importRequestID) => {
            let group, project, diagram, channel;

            Promise.all([
                ProjectRepository.getProject(projectID),
                DiagramAction.fetchDiagramOnce(projectID, diagramID)
            ]).then(values => {
                project = values[0];
                diagram = DiagramRepository.getDiagrams({
                    context: {
                        projectId: projectID
                    }
                }).get(diagramID);
                Messenger.onDiagram(projectID, diagramID);
                messageNotify.setContext({
                    projectId: projectID,
                    diagramId: diagramID
                });

                channel = Radio.channel(`diagrams:${diagram.id}`);

                return Promise.all([
                    GroupRepository.getGroup(project.getGroupId())
                ]);
            }).then(values => {
                group = values[0];
                setTitle(`Diagram Import - ${diagram.get('name')}`);

                globalMenuView.showItemList(group);
                headerView.showGroup(group);
                headerView.showGroupLicense(group);
                sidepanelView.close();

                const groupMember = group.getMembers().getMemberByUser(user);
                const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                const projectMember = project.getMembers().getMemberByUser(user);
                const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';

                return Promise.all([
                    GroupRoleRepository.find(group).getRole(groupRoleID),
                    ProjectRoleRepository.find(group).getRole(projectRoleID),
                ]);
            }).then(values => {
                const groupRole = values[0];
                const projectRole = values[1];
                const dt = DiagramContext.parseDtFromURLParams();
                const context = new DiagramContext(appInfo, user, group, groupRole, project, projectRole, diagram, dt);

                rootView.showChildView('body', new DiagramImportView({
                    model: diagram,
                    context: context,
                    channel: channel,
                    importRequestID: importRequestID,
                    messengerChannel: messengerChannel
                }));
            }, projectReject(projectID));
        });

        Router.on('diagramDiff', (projectID, diagramID) =>{
            const urlParams = new URLSearchParams(location.search);
            const dt = urlParams.get('dt');
            DiagramAction.fetchDiagramsOnce(projectID, dt);

            Promise.all([
                ProjectRepository.getProject(projectID),
                DiagramAction.fetchDiagramOnce(projectID, diagramID, dt)
            ]).then(values => {
                const project = values[0];
                const diagram = DiagramRepository.getDiagrams({
                    context: {
                        projectId: projectID,
                        dt: dt
                    }
                }).get(diagramID);
                Messenger.onDiagram(projectID, diagramID);
                messageNotify.setContext({
                    projectId: projectID,
                    diagramId: diagramID
                });

                const channel = Radio.channel(`diagrams:${diagram.id}:diff`);

                GroupRepository.getGroup(project.getGroupId()).then(group => {
                    setTitle(`Diagram - ${diagram.get('name')}`);
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();
                    const groupMember = group.getMembers().getMemberByUser(user);
                    const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                    const projectMember = project.getMembers().getMemberByUser(user);
                    const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                    Promise.all([
                        GroupRoleRepository.find(group).getRole(groupRoleID),
                        ProjectRoleRepository.find(group).getRole(projectRoleID),
                    ])
                        .then(values => {
                            const groupRole = values[0];
                            const projectRole = values[1];
                            const dt = DiagramContext.parseDtFromURLParams();
                            const context = new DiagramContext(appInfo, user, group, groupRole, project, projectRole, diagram, dt);

                            rootView.showChildView('body', new DiffView({
                                model: diagram,
                                context: context,
                                channel: channel,
                                messengerChannel: messengerChannel
                            }));
                        });
                });
            }, projectReject(projectID));
        });

        const actionViews = {};
        const ProcessViewState = Backbone.Model.extend({
            getTarget: function() {
                return this.get('target');
            },

            setTarget: function (target) {
                if (this.getTarget() && target && this.getTarget().id === target.id) {
                    return;
                }
                this.set({target: target});
            }
        });

        const renderProcess = (projectId, processId) => {
            ProjectRepository.getProject(projectId)
                .then(project => {
                    Messenger.onAction(projectId, processId);
                    messageNotify.setContext({
                        projectId: projectId,
                        actionId: processId
                    });

                    GroupRepository.getGroup(project.getGroupId()).then(group => {
                        globalMenuView.showItemList(group);
                        headerView.showGroup(group);
                        headerView.showGroupLicense(group);
                        sidepanelView.close();
                        const groupMember = group.getMembers().getMemberByUser(user);
                        const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                        const projectMember = project.getMembers().getMemberByUser(user);
                        const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                        Promise.all([
                            GroupRoleRepository.find(group).getRole(groupRoleID),
                            ProjectRoleRepository.find(group).getRole(projectRoleID),
                        ])
                            .then(values => {
                                const groupRole = values[0];
                                const projectRole = values[1];
                                const context = new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);

                                if (!actionViews[project.id]) {
                                    actionViews[project.id] = new ActionView({
                                        model: new ProcessViewState({processID: processId}),
                                        context: context,
                                    });
                                    actionViews[project.id].on('before:destroy', () => {
                                        actionViews[project.id] = null;
                                    });
                                }

                                rootView.showChildView('body', actionViews[project.id]);

                                if (processId) {
                                    ActionRepository
                                        .find(project)
                                        .get(processId)
                                        .then(process => {
                                            setTitle(`Action - ${process.get('name')}`);
                                            actionViews[project.id].model.setTarget(process);
                                        })
                                        .catch(() => {
                                            processReject(processId, context);
                                        });
                                } else {{
                                    setTitle(`Project - ${project.get('name')}`);
                                    actionViews[project.id].model.setTarget(null);
                                }}
                            });
                    });
                }, projectReject(projectId));
        };

        Router.on('processDashboard', projectId => {
            renderProcess(projectId, null);
        });

        Router.on('process', (projectId, processId) =>{
            renderProcess(projectId, processId);
        });

        Router.on('processImportRequest', (projectId, processId, importRequestId) => {
            ProjectRepository.getProject(projectId).then(project => {
                const groupId = project.getGroupId();
                GroupRepository.getGroup(groupId).then(group => {
                    globalMenuView.showItemList(group);
                    headerView.showGroup(group);
                    headerView.showGroupLicense(group);
                    sidepanelView.close();

                    const groupMember = group.getMembers().getMemberByUser(user);
                    const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                    const projectMember = project.getMembers().getMemberByUser(user);
                    const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                    Promise.all([
                        GroupRoleRepository.find(group).getRole(groupRoleID),
                        ProjectRoleRepository.find(group).getRole(projectRoleID),
                    ])
                        .then(values => {
                            const groupRole = values[0];
                            const projectRole = values[1];
                            ActionRepository.find(project).get(processId).then(process => {
                                (new ActionImportRepository(project, process)).preview(importRequestId)
                                    .then(importRequest => {
                                        const context = new ActionContext(appInfo, user, group, groupRole, project, projectRole, process);

                                        rootView.showChildView('body', new ActionImportView({
                                            model: importRequest,
                                            context: context
                                        }));
                                    });
                            }, processReject(processId, project));
                    });
                }, groupReject(groupId));
            }, projectReject(projectId));
        });

        Router.on('dataContentDashboard', projectId => {
            ProjectRepository.getProject(projectId)
                .then(project => {
                    Messenger.onProject(projectId);
                    messageNotify.setContext({projectId: projectId});

                    GroupRepository.getGroup(project.getGroupId())
                        .then(group => {
                            messageNotify.setContext({projectId: projectId});
                            Messenger.onProject(projectId);
                            setTitle(`Project - ${project.get('name')}`);
                            globalMenuView.showItemList(group);
                            headerView.showGroup(group);
                            headerView.showGroupLicense(group);
                            sidepanelView.close();
                            const groupMember = group.getMembers().getMemberByUser(user);
                            const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                            const projectMember = project.getMembers().getMemberByUser(user);
                            const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                            Promise.all([
                                GroupRoleRepository.find(group).getRole(groupRoleID),
                                ProjectRoleRepository.find(group).getRole(projectRoleID),
                            ])
                                .then(values => {
                                    const groupRole = values[0];
                                    const projectRole = values[1];
                                    const context = new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);

                                    rootView.showChildView('body', new DataContentDashboardView({
                                        model: project,
                                        context: context
                                    }));
                                });
                        });
                }, projectReject(projectId));
        });

        Router.on('dataContent', (projectId, contentId) => {
            ProjectRepository.getProject(projectId)
                .then(project => {
                    GroupRepository.getGroup(project.getGroupId()).then(group => {
                        ContentRepository.find(project)
                            .fetchContentOnce(contentId)
                            .then(content => {
                                messageNotify.setContext({projectId: projectId});
                                Messenger.onContent(projectId, contentId);
                                setTitle(`Content - ${content.getName()}`);
                                globalMenuView.showItemList(group);
                                headerView.showGroup(group);
                                headerView.showGroupLicense(group);
                                sidepanelView.close();
                                const groupMember = group.getMembers().getMemberByUser(user);
                                const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
                                const projectMember = project.getMembers().getMemberByUser(user);
                                const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
                                Promise.all([
                                    GroupRoleRepository.find(group).getRole(groupRoleID),
                                    ProjectRoleRepository.find(group).getRole(projectRoleID),
                                ])
                                    .then(values => {
                                        const groupRole = values[0];
                                        const projectRole = values[1];
                                        const context = new DataContentContext(appInfo, user, group, groupRole, project, projectRole, content);

                                        rootView.showChildView('body', new DataContentView({
                                            model: content,
                                            context: context
                                        }));
                                    });
                            });
                    });
                }, projectReject(projectId));
        });

        Router.on('feedback:ideas', () => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            const context = applicationContext;

            setTitle(`要望箱`);

            Promise.all([
                IdeaCollectionRepository.userIdeas(user).fetchFirstPage(10),
                IdeaCollectionRepository.publicIdeas(user).fetchFirstPage(20)
            ])
                .then(values => {
                    const myCollection = values[0];
                    const publicCollection = values[1];
                    rootView.showChildView('body', new IdeaListView({
                        context: context,
                        myCollection: myCollection,
                        publicCollection: publicCollection
                    }));
                });
        });

        Router.on('feedback:idea', (ideaID) => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            IdeaRepository
                .fetchByID(ideaID)
                .then(idea => {
                    setTitle(`要望箱: ${idea.getTitle()}`);
                    if(!idea) {
                        const statusCode = 404;
                        rootView.showChildView('body', new ErrorView({
                            title: I18next.t('error:error_page.feedback.404.title'),
                            user: user,
                            statusCode: statusCode
                        }));
                        return;
                    }

                    rootView.showChildView('body', new IdeaDetailView({
                        model: idea
                    }));
                });
        });

        Router.on('feedback:admin:ideas', () => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }
            const permitted = user.isSiteAdmin() || user.hasFeedbackAdminPermission();
            if (!permitted) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            setTitle(`要望管理`);
            rootView.showChildView('body', new IdeaAdminView({
                isSiteAdmin: user.isSiteAdmin()
            }));
        });

        Router.on('feedback:admin:idea', (ideaID) => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }
            const permitted = user.isSiteAdmin() || user.hasFeedbackAdminPermission();
            if (!permitted) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            IdeaRepository
                .fetchByID(ideaID)
                .catch(() => {
                    const statusCode = 404;
                    rootView.showChildView('body', new ErrorView({
                        title: I18next.t('error:error_page.feedback.404.title'),
                        user: user,
                        statusCode: statusCode
                    }));
                })
                .then(idea => {

                    setTitle(`要望 - ${idea.getTitle()}`);
                    rootView.showChildView('body', new IdeaAdminDetailView({
                        model: idea
                    }));
                });
        });

        Router.on('feedback:admin:idea:edit', (ideaID) => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }
            const permitted = user.isSiteAdmin() || user.hasFeedbackAdminPermission();
            if (!permitted) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            IdeaRepository.fetchByID(ideaID)
                .catch(() => {
                    const statusCode = 404;
                    rootView.showChildView('body', new ErrorView({
                        title: I18next.t('error:error_page.feedback.404.title'),
                        user: user,
                        statusCode: statusCode
                    }));
                })
                .then(idea => {

                    setTitle(`要望 - ${idea.getTitle()}`);
                    rootView.showChildView('body', new IdeaAdminEditView({
                        model: idea
                    }));
                });
        });

        Router.on('feedback:announcements', () => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            setTitle(`最新のお知らせ`);
            rootView.showChildView('body', new AnnouncementView({
                isSiteAdmin: user.isSiteAdmin()
            }));
        });

        Router.on('feedback:announcement', (announcementID) => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            AnnouncementRepository.fetchAnnouncement(announcementID)
                .then((announcement) => {
                    setTitle(`お知らせ`);
                    rootView.showChildView('body', new AnnouncementDetailView({
                        model: announcement
                    }));
                });
        });

        Router.on('feedback:admin:announcements', () => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }
            const permitted = user.isSiteAdmin() || user.hasFeedbackAdminPermission();
            if (!permitted) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            setTitle(`アナウンスの管理`);
            rootView.showChildView('body', new AnnouncementManageView({

            }));
        });

        Router.on('feedback:admin:announcement', (announcementID) => {
            if (!user) {
                rootView.showChildView('body', new SignInView());
                return;
            }
            const permitted = user.isSiteAdmin() || user.hasFeedbackAdminPermission();
            if (!permitted) {
                rootView.showChildView('body', new SignInView());
                return;
            }

            headerView.hideGroup();
            headerView.hideGroupLicense();
            sidepanelView.close();
            globalMenuView.showItemList(user);

            AnnouncementManageRepository.fetchAnnouncement(announcementID)
                .then((announcement) => {
                    setTitle(`お知らせ`);
                    rootView.showChildView('body', new AnnouncementManageDetailView({
                        model: announcement
                    }));
                });
        });

        Backbone.history.start({pushState: true, root: '/'});
    }
});

const getBrowserLanguages = function() {
    return window.navigator.languages || [
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage
    ];
};

UserRepository.getLoginUser()
    .then(user => {
        let language = null;
        if(user && user.getLocale()) {
            language = user.getLocale();
        } else {
            const hasJapanese = _.contains(
                _.map(getBrowserLanguages(), l => l.split('-')[0]), 'ja');
            language = hasJapanese ? 'ja' : 'en';
        }
        const opts = {
            lng: language,
            fallbackLng: 'en',
            ns: [
                'base',
                'module/word',
                'error',
                'validation',
                'diagram',
                'view',
                'view/invitation',
                'view/account',
                'view/user-dashboard',
                'view/group-dashboard',
                'view/project-dashboard',
                'view/diagram',
                'view/process',
                'view/data',
                'model'],
            defaultNS: 'base',
            resources: ressBundle,
            load: 'languageOnly',
            interpolation: {
                prefix: '%{',
                suffix: '}'
            },
            backend: {
                loadPath: function(lng, ns) {
                    return `/locales/${lng}/${ns}.json`;
                }
            }
        };
        I18next.init(opts);

        const timeLocale = user ? user.getTimeLocale() : language;
        MomentConfig.setLocale(timeLocale);
        MomentConfig.setTimezone('+09:00');

        const app = new App();
        app.start();

        // ログイン時でも、グループへの招待メール経由で、
        // メールアドレス追加の場合には、ユーザ情報編集モーダルを表示させる
        if (user && user.get('invite_token')) {
            _.delay(function () {
                const modal = new ModalView({
                    model: this.model,
                    title: I18next.t('title.user.setting'),
                    saveButtonEnable: true,
                    bodyView: new UserSettingModal({user: this.model}),
                    onChildviewSave: function() {
                        if(this.getOption('bodyView').setting()) {
                            this.disableButtons();
                            this.hide();
                        }
                    }
                });
                modal.show();
            }, 500);
        }
    });

AppInfoRepository.get().then(appInfo => {
    GA.initialize(appInfo.getGATrackID(), appInfo.getGATrackDomain());
    UserRepository.getLoginUser().then(user => {
        const debugContext = (new DebugContextRepository()).fetch();

        if (debugContext.getOptions().trackJSIsEnabled()) {
            Trackjs.initialize(appInfo, user);
        } else {
            Logger.info('TrackJS is disabled, initialize skipped.');
        }

        // Rollbar.initialize(
        //     appInfo.getRollbarToken(), appInfo.getRollbarEnv(),
        //     appInfo.getCodeVersion(), user
        // );
    });
});



// WEBPACK FOOTER //
// ./balus/ui/view/index.js